<template>
  <div>
    <div>
      <w-input class="form-group col-12" :model="$schema.data.contractor.displayName" />

      <w-input class="form-group col-12" :model="$schema.data.contractor.nip" />

      <w-input class="form-group col-12" :model="$schema.data.contractor.bankAccount" />

      <address-form class="form-group col-12" :model="$schema.data.contractor.address" />
    </div>

    <div class="d-flex justify-content-between mt-5">
      <w-button text="Anuluj" class="btn-secondary" @click="$emit('close')" />

      <w-button text="Zapisz" class="btn-primary" @click="saveData" />
    </div>
  </div>
</template>

<script>
import AddressForm from '@/components/forms/document/Address.vue';
import { paymentDetailsEditMixin } from '@/mixins/paymentDetailsEdit';
import schema from '@/schemas/koPaymentData.schema';

export default {
  components: { AddressForm },
  mixins: [paymentDetailsEditMixin],
  schema
};
</script>
